import type { KnowledgeCapabilitySnapshot } from "@ai-sales/contracts";

const statusLabels: Record<KnowledgeCapabilitySnapshot["status"], string> = {
  available: "可用",
  unavailable: "未启用",
  permission_required: "需要当前用户授权",
  api_unsupported: "当前环境不支持",
  temporarily_unavailable: "暂时不可用"
};

export function CapabilityStatusPanel(props: {
  snapshots: KnowledgeCapabilitySnapshot[];
  canManage: boolean;
  busy: boolean;
  onProbe: () => Promise<void>;
}) {
  const integration = props.snapshots.find((snapshot) => snapshot.source === "org_integration");
  const currentUser = props.snapshots.find((snapshot) => snapshot.source === "current_user");
  return <section className="admin-card">
    <div className="admin-card--header">
      <div>
        <h2>Salesforce Knowledge 能力</h2>
        <p>分别检测组织能力和当前用户可见能力，不同步文章，也不会读取 CRM 业务记录。</p>
      </div>
      {props.canManage ? <button className="button button--secondary" type="button" disabled={props.busy} onClick={() => void props.onProbe()}>
        {props.busy ? "检测中…" : "重新检测"}
      </button> : null}
    </div>
    <div className="metric-grid">
      <CapabilityCard label="组织能力" snapshot={integration} />
      <CapabilityCard label="当前用户" snapshot={currentUser} />
    </div>
    {integration && currentUser && integration.status !== currentUser.status
      ? <div className="admin-warning-list"><p>组织能力与当前用户能力不同。正式场景必须以当前用户结果为准。</p></div>
      : null}
  </section>;
}

function CapabilityCard(props: {
  label: string;
  snapshot?: KnowledgeCapabilitySnapshot;
}) {
  const snapshot = props.snapshot;
  return <article className="metric-card">
    <span>{props.label}</span>
    <strong>{snapshot ? statusLabels[snapshot.status] : "未检测"}</strong>
    <small>{snapshot
      ? `${snapshot.articleObjectApiNames.length} 种文章类型 · ${snapshot.supportedLanguages.length} 种语言 · ${snapshot.supportedChannels.length} 个渠道 · ${snapshot.dataCategoryGroups.length} 个数据分类组`
      : "运行能力检测后显示结果"}</small>
    {snapshot ? <details><summary>检测依据</summary>
      <p>{snapshot.reasonCode}</p>
      {snapshot.errorSummary ? <p>{snapshot.errorSummary}</p> : null}
      <p>{new Date(snapshot.checkedAt).toLocaleString()}</p>
    </details> : null}
  </article>;
}
